export const defaultLatLng = {
  latitude: 55.02602,
  longitude: -1.62762,
};

export { defaultLatLng as default };
